export default __webpack_public_path__ + "static/media/cross.cf409aa2.png";